<template>
    <select v-model="destinationPref" name="" :class=buttonStatusClass>
        <option value="">
            選択してください
        </option>
        <option v-for="(value, key) in destinationPrefItemList" :value="key" v-show="value.parentIdList[condition.selectedDestinationArea.value] || !condition.selectedDestinationArea.value">
            {{ value.name }}
        </option>
    </select>
</template>

<script>
    import { ref, watchEffect, onMounted } from 'vue'
    export default ({
        props: {
            master : {type: Object, require: true},
            condition: {type: Object, require: true},
        },
        emits: ['destinationPref'],
        setup (props, context) {
            const buttonStatusClass = ref('buttonStatusClass')
            const destinationPref = ref(props.condition.selectedDestinationPref.value)
            let defaultSelectedDestinationPref = props.condition.selectedDestinationPref.value
            const destinationPrefItemList = JSON.parse(props.master.destinationPrefItemList)

            // 監視の実装
            watchEffect(() => {
                destinationPref.value = defaultSelectedDestinationPref

                // 都道府県が変更だったら
                // 下層ボタンの調整
                if (props.condition.selectedDestinationArea.value) {
                    buttonStatusClass.value = ""
                } else {
                    buttonStatusClass.value = "buttonStatusClass"
                }
            })

            watchEffect(() => {
                context.emit("destinationPref", destinationPref);
            })

            // 完了時
            onMounted(() => {
                defaultSelectedDestinationPref = ""
            })
            
            return {
                destinationPrefItemList,
                buttonStatusClass,
                destinationPref,
            }
        },
    })
</script>